"use client";
import { ErrorAlert } from "@components/CustomAlert";
import { useBill } from "@core/hooks/endpoints/useBill";
import { useUser } from "@core/hooks/endpoints/useUser";
import { useStoreDevice } from "@core/store/storeDevice";
import { requestAlegriia } from "@utils/requests";
import axios, { AxiosError } from "axios";
import { useCallback, useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { useRestaurant } from "../../core/hooks/endpoints/useRestaurant";
import { useStore } from "../../core/store";

export const SubscribeTopics = () => {
  const { notificationToken, setTopics, topics } = useStore(
    useShallow((state) => ({
      notificationToken: state.notificationToken,
      setTopics: state.setTopics,
      topics: state.topics,
    })),
  );
  const { restaurant } = useRestaurant();
  const { data: bill } = useBill();
  const user = useUser();

  const { stationDevice } = useStoreDevice(
    useShallow((state) => ({
      stationDevice: state.stationDevice,
    })),
  );

  const subscribeTopic = useCallback(
    async (token: string, topics: string[]) => {
      try {
        await requestAlegriia.post(
          "/notifications/newTopic",
          { tokenFCM: token, topics },
          {
            headers: { Authorization: token },
          },
        );
      } catch (err) {
        const error = err as Error | AxiosError;
        console.log(error);
        ErrorAlert(
          axios.isAxiosError(error)
            ? error.response?.data?.error?.toString()
            : error.toString(),
        );
      }
    },
    [],
  );

  useEffect(() => {
    registerFirebaseSW();
  }, []);

  useEffect(() => {
    if (notificationToken) {
      const finalTopics = [];
      //Aquí se pondrán todos los temas a los que se subscribirá para enviar las notificationes puch (FCM)
      if (topics?.includes("restaurant") && restaurant) {
        const addresses = restaurant.addresses ?? [];
        if (addresses.length === 0) return setTopics?.([]);

        //TOPIC: address-${idAddress} include all devices
        if (!stationDevice)
          addresses.forEach(({ idAddress }) =>
            finalTopics.push(`address-${idAddress}`),
          );

        //TOPIC: station-${idStation}
        if (stationDevice) finalTopics.push(`station-${stationDevice}`);
      }
      if (topics?.includes("client") && !!bill) {
        // TODO: Si no hay bill se envía una notificación?
        finalTopics.push(`bill-${bill.idBill}_user-${user.idUser}`);
      }
      if (!!finalTopics.length) subscribeTopic(notificationToken, finalTopics);
    }
  }, [
    subscribeTopic,
    setTopics,
    notificationToken,
    topics,
    restaurant,
    bill,
    user,
    stationDevice,
  ]);
  return null;
};

export const registerFirebaseSW = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js", { scope: "/" })
      .then(() => console.warn("SW registrado"))
      .catch((err) => console.error("Error registrando SW:", err));
  }
};
